import {useQuery} from 'react-query'
import {UserEditModalForm} from './UserEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getSingleTrigger} from '../core/_requests'
import { useCompanies } from '../../../../auth/core/Companies'

const UserEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {defaultCompany} = useCompanies()

  const {
    isLoading,
    data: trigger,
    error,
  } = useQuery(
    `${QUERIES.USERS_LIST}-user-${itemIdForUpdate}`,
    () => {
      return getSingleTrigger(itemIdForUpdate,defaultCompany?.company_id ?? '')
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <UserEditModalForm isUserLoading={isLoading} trigger={{_id: undefined}} />
  }

  if (!isLoading && !error && trigger) {
    return <UserEditModalForm isUserLoading={isLoading} trigger={trigger} />
  }

  return null
}

export {UserEditModalFormWrapper}
